module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/logo_c08-0be6e4418c1e7e6ade72fa7f24cb4e3a.jpg";